import React from 'react';

function Step() {
    const onboardingDescriptions = [
        {
            id: 1,
            text: "Here you will receive your caseload from Khan Communication Services and review the agency's policies."
        },
        {
            id: 2,
            text: "You can track your client's progress and create reports."
        },
        {
            id: 3,
            text: "You will also have access to a support staff dashboard where you can assign tasks to assistants and track their work with your clients."
        }
    ];

    return (
        <div style={{marginTop:'35px'}}>
            <div className="d-flex flex-column align-items-center">
                <ul className="w-75">
                    {onboardingDescriptions.map((item) => (
                        <li key={item.id} className="welcome-list">
                            {item.text}
                        </li>
                    ))}

                </ul>
            </div>
            <div className="d-flex  flex-column justify-content-start align-items-center">
                <p className='w-75 welcome-list'>
                    Create your profile now!
                </p>
            </div>
        </div>
    );
}

export default Step;
